import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../AxiosInstance";

const initialState = {
  ResidentData: {},
  VisitorData: {},
  StaffData: {},
  FaultReportData: {},
  ServiceRequestData: {},
  ParcelCollectionData: {},
  FacilityData: {},
  OverviewStatus: null,
};

export const getOverviewDatas = createAsyncThunk(
  "getOverviewDatas",
  async (data, { rejectWithValue }) => {
    const { propertyId, yearSorting, userRole, companyId } = data;
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}dashboard_overview?filter_role=${userRole}&year=${yearSorting}&company_id=${companyId}`
      );
      console.log(response)
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const OverViewDetailsReducer = createSlice({
  name: "OverViewDetails",
  initialState,
  reducers: {
    setOverViewDetailSliceToNull: (state) => {
      state.resident_analysis = {};
      state.VisitorData = {};
      state.StaffData = {};
      state.ServiceRequestData = {};
      state.FaultReportData = {};
      state.ParcelCollectionData = {};
      state.FacilityData = {};
      state.OverviewStatus = false;
    },
  },
  extraReducers: (builders) => {
    builders.addCase(getOverviewDatas.pending, (state) => {
      state.OverviewStatus = false;
    });
    builders.addCase(getOverviewDatas.fulfilled, (state, action) => {
      state.ResidentData = action.payload.data.total_visitor_count;
      state.VisitorData = action.payload.data.total_visitor_count;
      // state.StaffData = action.payload.data.data.overview.staff;
      state.ServiceRequestData =
        action.payload.data.adoc_visitor_analysis;
      state.FaultReportData = action.payload.data.pre_register_visitor_analysis;
      // state.ParcelCollectionData =
      //   action.payload.data.data.overview.parcel_collection;
      state.FacilityData = action.payload.data.users_analysis;
      state.OverviewStatus = false;
    });
    builders.addCase(getOverviewDatas.rejected, (state, action) => {
      state.ResidentData = {};
      state.VisitorData = {};
      state.StaffData = {};
      state.ServiceRequestData = {};
      state.FaultReportData = {};
      state.ParcelCollectionData = {};
      state.FacilityData = {};
      state.OverviewStatus = true;
    });
  },
});

export const { setOverViewDetailSliceToNull } = OverViewDetailsReducer.actions;
export default OverViewDetailsReducer.reducer;
